import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import withSyteApiStatus from "@/hocs/withSyteApiStatus";
import { encodeSpace } from "@/util";
import "./style.scss";

const SyteDiscoveryBanner = withSyteApiStatus(
  ({
    sku,
    placement,
    productImgPath,
    handleClick,
    details,
    syteAppIsReady,
    ...otherProps
  }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
      if (window.SyteApp?.isLoaded && window.SyteApp?.isReady) {
        window.SyteApp?.subscribeEvent?.("discoveryButtonImpression", e => {
          setIsLoaded(true);
        });
      }

      return () => {
        setIsLoaded(false);
      };
    }, []);

    const clickHandler = e => {
      e.preventDefault();
      if (handleClick && details) {
        handleClick(details);
      }
    };

    if (!Boolean(syteAppIsReady)) return null;

    return (
      <>
        {isLoaded ? null : <Skeleton height={130} width={"100%"} />}
        <div
          id="syte-discovery-banner"
          data-image-src={encodeSpace(productImgPath)}
          data-sku={sku}
          data-placement={placement}
          onClick={clickHandler}
          {...otherProps}
        ></div>
      </>
    );
  }
);

export default SyteDiscoveryBanner;
